import { Text, type TypeTextProps } from '@thefarmersfront/kitchen';

import type { CustomHeaderGroupProps } from 'ag-grid-react';

import type { TypeGetStorageFeeDailySkusResponse } from '~/types/settlement.types';

import styles from './../CustomHeaders.module.scss';

type TypeStorageDetailCustomHeaderGroupProps = {
  /**
   * @defaultValue `semi-bold`
   */
  weight?: TypeTextProps['weight'];
  /**
   * @defaultValue `left`
   */
  align?: TypeTextProps['align'];
} & CustomHeaderGroupProps<TypeGetStorageFeeDailySkusResponse['data'][number]>;

/**
 * [정산관리][보관비 조회] 일자 별 보관비 상세 모달 > 헤더 그룹 컴포넌트
 */
const StorageDetailCustomHeaderGroup = ({
  weight = 'semi-bold',
  align = 'left',
  ...props
}: TypeStorageDetailCustomHeaderGroupProps) => {
  return (
    <Text className={`${styles['width-100']} ${styles['ellipsis']}`} size="large" weight={weight} align={align}>
      {props.displayName}
    </Text>
  );
};

export default StorageDetailCustomHeaderGroup;
